import {syncSchooxUserFromSchoox} from 'Core/api/schooxApi';
import {
  Brokerage,
  getAndSyncSchooxUser,
  isSchooxComplete,
  isSchooxLoading,
  isSchooxUserSynced,
  SchooxUserActionType,
  setSchooxPercentage,
  toggleSchooxConfirmation,
  isSchooxPopupClosedEvent,
} from 'Core/ducks/schoox';
import {AsyncResult} from 'Core/models/Async';
import {getOAuthVariablesForAgentType} from 'Core/refreshTokenUtilityMethods';
import {all, call, put, takeLatest, takeLeading} from 'redux-saga/effects';
import * as E from 'fp-ts/lib/Either';

function pushOrSpread(arrayRef: number[], newValue: number) {
  if (arrayRef) {
    arrayRef.push(newValue);
  } else {
    arrayRef = [];
    arrayRef.push(newValue);
  }
}

export function doBufferInterval(setDisplayPercent: (value: ((prevState: any) => any) | any) => void, percentage: any) {
  setDisplayPercent(percentage ? percentage : 0);
  setSchooxPercentage(percentage);
}

function* redirectSchoox() {
  try {
    yield put(toggleSchooxConfirmation(false));
    const oAuthProviderVariables = getOAuthVariablesForAgentType();
    window.open(oAuthProviderVariables.ISAM_SCHOOX);
  } catch (e) {
    console.log(e);
  }
}

function isOverOneHundred(callsMade: number, totalCallsToDispatch: number) {
  return parseInt(String(callsMade)) / parseInt(String(totalCallsToDispatch)) < 1;
}

function isSyncFailed(name: string, unitId: number) {
  if (unitId == null || (unitId && isNaN(unitId))) {
    throw new Error('Schoox sync failed for ' + name + ': ' + unitId);
  }
  return false;
}

function fetchTotalSchooxUnits(brokerages: Brokerage[]) {
  let totalSchooxUnits: number = brokerages.length;
  brokerages.map(brokerage => (totalSchooxUnits = totalSchooxUnits + brokerage.territories.length));
  brokerages.map(brokerage =>
    brokerage.territories.map(territory => (totalSchooxUnits = totalSchooxUnits + territory.regions.length))
  );
  brokerages.map(brokerage =>
    brokerage.territories.map(territory =>
      territory.regions.map(region => (totalSchooxUnits = totalSchooxUnits + region.recruiterCodes.length))
    )
  );
  brokerages.map(brokerage =>
    brokerage.territories.map(territory =>
      territory.regions.map(region =>
        region.recruiterCodes.map(
          recruiterCode => (totalSchooxUnits = totalSchooxUnits + recruiterCode.agentIds.length)
        )
      )
    )
  );

  return totalSchooxUnits;
}

function getSyncProgressPercentage(callsMade: number, totalAPICalls: number) {
  let percent = Math.floor((callsMade / totalAPICalls) * 100);
  return percent > 100 ? 100 : percent;
}

function* syncSchooxUserFromAPI(action: ReturnType<typeof getAndSyncSchooxUser>) {
  try {
    yield put(isSchooxLoading(true, 'Fetching your Schoox profile...'));
    const result: AsyncResult<Object> = yield call(syncSchooxUserFromSchoox);
    yield put(isSchooxLoading(true, 'Synchronizing schoox profile', 1));

    if (E.isRight(result)) {
      yield put(isSchooxUserSynced(true));
      yield put(isSchooxComplete(true));
      yield put(isSchooxLoading(false));
      yield put(toggleSchooxConfirmation(true));
      yield put(isSchooxPopupClosedEvent(false));
    } else {
      yield put(isSchooxUserSynced(false));
      yield put(isSchooxComplete(true));
      yield put(isSchooxLoading(false));
      yield put(toggleSchooxConfirmation(true));
      yield put(isSchooxPopupClosedEvent(false));
    }
  } catch (e) {
    yield put(isSchooxComplete(false));
    yield put(isSchooxLoading(false));
    yield put(toggleSchooxConfirmation(true));
    yield put(isSchooxPopupClosedEvent(false));
  }
}

export function* fetchRedirectSchooxSaga() {
  yield takeLatest(SchooxUserActionType.REDIRECT_SCHOOX, redirectSchoox);
}

export function* fetchSyncSchooxSaga() {
  yield takeLeading(SchooxUserActionType.GET_AND_SYNC_SCHOOX_USER, syncSchooxUserFromAPI);
}

export default function*() {
  yield all([fetchRedirectSchooxSaga(), fetchSyncSchooxSaga()]);
}
